import React from 'react';
import { NavLink } from 'react-router-dom';
import { IconContext } from "react-icons";
import { FaRegCheckCircle } from 'react-icons/fa';

require('../../css/components/AssetListSlat.scss');

'use strict';

export default class AssetListSlat extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        var asset = this.props.asset;

        var assignment = this.props.assignment;
        var assignmentComplete = assignment && assignment.displayAsComplete;

        var urlHash = this.props.urlHash;

        var msgKey = "msg-" + this.props.parentKey;
        var copy = this.props.copy;

        return React.createElement(
            'li',
            { className: 'listAssetSlat' },
            [
                React.createElement(
                    'div',
                    {
                        className: "d-flex"
                    },
                    [
                        this.props.useRouter ?
                            React.createElement(
                                NavLink,
                                {
                                    className: "inlineBlockShrink",
                                    to: asset.url + urlHash,
                                    location: this.props.location,
                                    isActive: () => {
                                        return asset.url === this.props.location.pathname;
                                    },
                                    "data-url": asset.url
                                },
                                asset.asset.title) :
                            React.createElement(
                                'a',
                                {
                                    className: "inlineBlockShrink",
                                    href: asset.url + urlHash,
                                    "data-url": asset.url
                                },
                                asset.asset.title),

                        !assignment ?
                            null :
                            React.createElement(
                                'div',
                                {
                                    className: "d-flex flex-column justify-content-center ml-2"
                                },
                                    assignment.progress >= 1.0 ?
                                        React.createElement(
                                            'a',
                                            {
                                                className: "btn collapsed", "data-toggle": "collapse", "data-target": "#" + msgKey, "aria-controls": msgKey, "aria-expanded": false, title: copy.completedTooltip
                                            },
                                            React.createElement(IconContext.Provider, { value: { className: "icon" } }, React.createElement(FaRegCheckCircle, { color: "#009E0F" }))
                                        ) :
                                        null
                            )
                    ]
                )
            ],
            !assignment ?
                null :
                assignmentComplete ?
                    React.createElement(
                        'div',
                        {
                            id: msgKey,
                            className: "collapse",
                        },
                        React.createElement(
                            'div',
                            {
                                className: "msg",
                                style: { color: "#009E0F" }
                            },
                            copy.completedMessage
                        )
                    ) :
                    assignment.progress >= 1.0 ?
                        React.createElement(
                            'div',
                            {
                                id: msgKey,
                                className: "collapse",
                            },
                            React.createElement(
                                'div',
                                {
                                    className: "msg",
                                    style: { color: "#DB8008" }
                                },
                                copy.actionRequiredMessage
                            )
                        ) :
                        null,
            asset.asset.type === "Video" && assignment ?
                React.createElement(
                    'div',
                    {
                        className: "progressBarContainer"
                    },
                    React.createElement(
                        'div',
                        {
                            className: "progressBar",
                            style: { width: (((this.props.overrideProgress && asset.url === this.props.location.pathname) ? this.props.overrideProgress : assignment.progress) * 100) + "%" }
                        }
                    )
                ) :
                null
        );
    }
}